import { createElement } from "react";
const CustomerRender = ({}) => {
  return createElement("div", null, "Not available");
};
export default CustomerRender;
//# sourceMappingURL=customer-render.js.map